import { BoxDetailPlcProps } from '@/box/interface'
import { Column } from '@/shared/Column'
import { TemplatePlcTable } from '@/template/plc/table'
import React from 'react'

export const BoxDetailPlc: React.FC<BoxDetailPlcProps> = (
  props: BoxDetailPlcProps
) => {
  const { contactTemplate } = props
  const columns: Column[] = [
    {
      index: 4,
      hidden: true
    }
  ]

  return <TemplatePlcTable columns={columns} data={contactTemplate?.plcs} />
}
